import Dynamic from './Dynamic'
import Standard from './Standard'
import TotalBudget from './TotalBudget'

export default {
  dynamic: Dynamic,
  standard: Standard,
  total_budget: TotalBudget
}
